import { gql } from '@apollo/client';

export const CREATE_JOB_REPORT_RUN = gql`
    mutation createJobReportRun($jobReport: CreateJobReportRun!) {
        facility {
            report {
                createJobReportRun(input: $jobReport) {
                    id
                    correlationId
                }
            }
        }
    }
`;
